import React from "react";
import "./App.css";
import Chat from "./components/organisms/Chat";

export function App() {
  return (
    <>
      <Chat />
    </>
  );
}